module.exports = __webpack_public_path__ + "media/images/personal-talent-advocate-6c0a33d73e4973d275ceb47185581293.svg";